import { render, staticRenderFns } from "./MaterialsInformation.vue?vue&type=template&id=b0eed5d2&scoped=true&"
import script from "./MaterialsInformation.vue?vue&type=script&lang=js&"
export * from "./MaterialsInformation.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsInformation.vue?vue&type=style&index=0&id=b0eed5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0eed5d2",
  null
  
)

component.options.__file = "MaterialsInformation.vue"
export default component.exports